/**
 * Adds the class responsible for background color to the header when it reaches a fixed scroll-y position.
 */
window.onscroll = () => {
  const header = document.querySelector('header');
  const nav_y = 80;

  if (window.scrollY > nav_y) {    
    header.classList.add('fixed')
  } else {
    header.classList.remove('fixed')
  }
}

/**
 * Highlights the navigation text based on the current namespace.
 * @param {string} namespace 
 */
export function highlightText(namespace) {
  let pages = Array.from(nav_list.children);

  pages.forEach(page => {
    if (page.innerText.toLowerCase() == namespace) {
      page.children[0].classList.add('twclr')
    } else {
      page.children[0].classList.remove('twclr')
    }
  })
}